// extracted by mini-css-extract-plugin
export var loadingSpinner = "_3m-1";
export var standaloneTable = "_3m-0";